import { SignOffRequirement } from '@mnspro-cloud/services';
import {
  SignatureWithRequirement,
  SignOffsResponse,
} from '@mnspro-cloud/services/lib/mnspro-cloud/api/v2';
import moment from 'moment-timezone';
import {
  SignOffPerson,
  SignOffState,
} from '../SignOffButton/SignOffButton.interfaces';

export const getSigningPersons = (signOff: SignOffsResponse): SignOffPerson[] =>
  signOff.current.signatures.map(signOff => {
    return {
      personDisplayName: signOff.signer?.displayName ?? '',
      signOffDate: signOff.signedAt
        ? moment(signOff.signedAt).format('LL')
        : null,
    };
  });

const signaturesAreDone = (
  signatureWithRequirement: SignatureWithRequirement,
): boolean => {
  let isFulfilled = false;
  if (signatureWithRequirement.signOffRequirement === SignOffRequirement.all) {
    const signatures = signatureWithRequirement.signatures.filter(
      signature => signature.signedAt !== null,
    );
    isFulfilled =
      signatures.length === signatureWithRequirement.signatures.length;
  }
  if (signatureWithRequirement.signOffRequirement === SignOffRequirement.any) {
    const signedAt = signatureWithRequirement.signatures.some(
      signature => signature.signedAt !== null,
    );
    isFulfilled = signedAt;
  }
  return isFulfilled;
};

export const someBodyAboveSigned = (aboveSignOffs: SignOffsResponse[]) => {
  return aboveSignOffs.some(x => x.current.signatures.some(a => a.signedAt));
};

export const isAllSigningRequired = (signOff: SignOffsResponse): boolean =>
  signOff.current.signOffRequirement === SignOffRequirement.all;

export const determineSignOffState = (
  signaturesWithRequirement: SignatureWithRequirement,
): SignOffState => {
  switch (true) {
    case signaturesWithRequirement.signOffRequirement !==
      SignOffRequirement.none &&
      signaturesWithRequirement.signatures.length === 0:
      return SignOffState.CONFIGURATION_ISSUE;

    case signaturesWithRequirement.fulfilled &&
      signaturesWithRequirement.signOffRequirement !==
        SignOffRequirement.none &&
      signaturesWithRequirement.signatures.length > 0 &&
      signaturesAreDone(signaturesWithRequirement):
      return SignOffState.SIGNED_OFF;

    case !signaturesWithRequirement.fulfilled &&
      signaturesWithRequirement.signOffRequirement !==
        SignOffRequirement.none &&
      signaturesWithRequirement.signatures.length > 0:
      return SignOffState.NOT_SIGNED_OFF;

    default:
      return SignOffState.NOT_SIGNED_OFF;
  }
};

export const isLessonSignable = (currentTime: Date, lessonEnd: Date) =>
  moment(currentTime).isSameOrAfter(moment(lessonEnd).subtract(5, 'minutes'));
